import React from "react";

const ICONOS = {
  REALIZADO: { icono: "✓", color: "#15803d", etiqueta: "Confirmada" },
  CANCELADO: { icono: "✕", color: "#dc2626", etiqueta: "Cancelada" },
};

export default function IconoEstadoCita({ estado }) {
  const dato = ICONOS[estado];
  if (!dato) return null;

  return <span title={dato.etiqueta} aria-label={dato.etiqueta} style={{ color: dato.color, marginLeft: 5, fontWeight: 800 }} role="img">{dato.icono}</span>;
}
